import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <AppBar position="static" sx={{
      background: 'rgba(255,255,255,0.05)',
      backdropFilter: 'blur(16px)',
      boxShadow: 'none',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
    }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'white', letterSpacing: 1 }}>
          Nutscaper.com
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button component={Link} to="/" sx={{ color: 'rgba(255,255,255,0.85)', '&:hover': { color: '#EC4899' } }}>Home</Button>
          <Button component={Link} to="/app" sx={{ color: 'rgba(255,255,255,0.85)', '&:hover': { color: '#EC4899' } }}>App</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
